import Module from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/Module';
import helpDeskImg from '../img/home-cards/desk_help.jpg';
import {fsCustomEvent} from '@sinclair-digital/stl-common/src/analytics/fullStory';

export default new Module({
    moduleName: 'HelpDesk',
    title: 'Help Desk',
    moduleButtons: [
        {
            id: 'help_desk_button',
            text: 'Help',
            href: 'https://sinclairdigital.atlassian.net/servicedesk/customer/portal/2',
            backgroundSrc: helpDeskImg,
            buttonType: 'card',
            location: 'HomePage',
            openNewTab: true,
            onClick: () => fsCustomEvent('clickedHelpDeskCard'),
        },
    ],
});
